import { useEffect, useState } from 'react';

let shiftHeld = false;
const shiftListeners = new Set<(v: boolean) => void>();
let installed = false;

function installShift(): void {
  if (installed) return;
  installed = true;
  const set = (v: boolean) => {
    if (v === shiftHeld) return;
    shiftHeld = v;
    for (const fn of shiftListeners) fn(v);
  };
  window.addEventListener('keydown', (e) => e.key === 'Shift' && set(true));
  window.addEventListener('keyup', (e) => e.key === 'Shift' && set(false));
  window.addEventListener('blur', () => set(false));
}

/** Umschalttaste gedrückt (Löschen ohne Nachfrage). */
export function useShiftHeld(): boolean {
  const [v, setV] = useState(shiftHeld);
  useEffect(() => {
    installShift();
    shiftListeners.add(setV);
    return () => {
      shiftListeners.delete(setV);
    };
  }, []);
  return v;
}

export function isShiftHeld(): boolean {
  return shiftHeld;
}

/** Aktuelle Zeit, aktualisiert im Intervall solange `active`. */
export function useNow(intervalMs: number, active = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const first = setTimeout(() => setNow(Date.now()), 0);
    const t = setInterval(() => setNow(Date.now()), intervalMs);
    return () => {
      clearTimeout(first);
      clearInterval(t);
    };
  }, [intervalMs, active]);
  return now;
}

/** Nutzer bevorzugt reduzierte Bewegung (System oder Einstellung). */
export function prefersReducedMotion(settingReduced: boolean | undefined): boolean {
  if (settingReduced) return true;
  try {
    return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  } catch {
    return false;
  }
}

/** Verbleibende Sekunden bis `untilMs` (0 = abgelaufen), sekündlich aktualisiert. */
export function useCountdown(untilMs: number): number {
  const [left, setLeft] = useState(0);
  useEffect(() => {
    const tick = () => {
      const l = Math.max(0, Math.ceil((untilMs - Date.now()) / 1000));
      setLeft(l);
      return l;
    };
    const first = setTimeout(tick, 0);
    const t = setInterval(() => {
      if (tick() === 0) clearInterval(t);
    }, 500);
    return () => {
      clearTimeout(first);
      clearInterval(t);
    };
  }, [untilMs]);
  return left;
}
